import { Content } from '@/types/content';
import getConfig from 'modules/config';

export const shouldPageBeHiddenFromIndexing = (pageData: Content): Boolean => {
  const isEtikettPage = pageData.type === 'front' && pageData.data.publishedUrl.includes('etikett');

  const hiddenFrontPages = ['/creative-studio', '/marbodal'];
  const isHiddenFrontPage = pageData.type === 'front' && hiddenFrontPages.includes(pageData.data.publishedUrl);
  const isNativeArticle = pageData.type === 'article' && pageData.meta.isNativeAd;

  const isHiddenFromLabrador = pageData.meta.seoDisableIndexing;
  const isHiddenEtikettPage =
    isEtikettPage && (pageData.data.counter || '') <= getConfig('seo.tagPagesNoIndexThreshold');

  return isHiddenFrontPage || isNativeArticle || isHiddenFromLabrador || isHiddenEtikettPage;
};
